/**
 * @author Geider Arevalo
 * @since v0.0.1
 * @date 25/01/2022
 */
import React, {memo, useMemo} from 'react';
import PropTypes from 'prop-types';
import DetailAuditor from './components/Auditor';
import DetailsAuditionDate from './components/AuditionDate';
import DetailsAuditDateRange from './components/AuditDateRange';
import DetailsLocation from './components/Location';
import DetailsNumber from './components/Number';
import DetailsSelect from './components/Select';
import DetailsText from './components/Text';
import DetailsInSituMeasure from './components/InSituMeasure';
import Evolution from '@/modules/audits/components/WrapperRunAudit/components/ManageAuditContent/components/WrapperFieldType/components/Evolution';
import Summary from '@/modules/audits/components/WrapperRunAudit/components/ManageAuditContent/components/WrapperFieldType/components/Summary';
import Objetive from '@/modules/audits/components/WrapperRunAudit/components/ManageAuditContent/components/WrapperFieldType/components/Objetive';
import RichText from '@/modules/audits/components/WrapperRunAudit/components/ManageAuditContent/components/WrapperFieldType/components/RichText';
import PoolsNumbers
from '@/modules/audits/components/WrapperRunAudit/components/ManageAuditContent/components/WrapperFieldType/components/PoolsNumbers';
import Contact
from '@/modules/audits/components/WrapperRunAudit/components/ManageAuditContent/components/WrapperFieldType/components/DedtailContact';

const WrapperFieldType = ({type, data, question, sectionId, isCover, ...props}) => {

  const render = useMemo(() => {
    switch (type) {
      case 'number':
        return <DetailsNumber question={question} {...props} entity={data}/>;
      case 'select':
        return <DetailsSelect question={question} {...props} entity={data}/>;
      case 'readingRegistry':
        return <DetailsInSituMeasure question={question} {...props} entity={data}/>;
      case 'audit_date':
        return <DetailsAuditDateRange sectionId={sectionId} question={question} isCover={isCover} entity={data}/>;
      case 'date':
        return <DetailsAuditionDate sectionId={sectionId} question={question} isCover={isCover} entity={data}/>;
      case 'location':
        return <DetailsLocation sectionId={sectionId} question={question} isCover={isCover} entity={data} />;
      case 'auditor':
        return <DetailAuditor sectionId={sectionId} question={question} isCover={isCover} entity={data}/>;
      case 'evolution':
        return <Evolution sectionId={sectionId} question={question} isCover={isCover} {...props} entity={data}/>;
      case 'summary':
        return <Summary sectionId={sectionId} question={question} isCover={isCover} {...props} entity={data}/>;
      case 'objective':
        return <Objetive sectionId={sectionId} question={question} isCover={isCover} {...props} entity={data}/>;
      case 'paragraph':
        return <RichText question={question} {...props} entity={data} />;
      case 'pools_reported':
        return <PoolsNumbers question={question} isCover={isCover} />;
      case 'pools_audited':
        return <PoolsNumbers question={question} isCover={isCover}/>;
      case 'pools_not_audited':
        return <PoolsNumbers question={question} isCover={isCover}/>;
      case 'contact_information':
        return <Contact question={question} isCover={isCover} />;
      // case 'hotel_contact':
      //   return <Contact question={question} isCover={isCover} />;
      // case 'emails':
      //   return <Contact question={question} isCover={isCover}/>;
      default:
        return <DetailsText question={question} {...props} entity={data} isCover={isCover} />;
    }
  }, [data, isCover, props, question, sectionId, type]);

  return (
    <div className="py-2">{render}</div>
  );
};

WrapperFieldType.propTypes = {
  type: PropTypes.string,
  data: PropTypes.object,
  question: PropTypes.object,
  isCover: PropTypes.bool,
  sectionId: PropTypes.string,
};

export default memo(WrapperFieldType);
